<img
  src="../../../../assets/no-results-found-directory-v2.svg"
  alt="No results found"
/>
<h4 class="mat-body-2">No results found</h4>
<div class="mat-body">
  You can search for people by their name, position or department.
</div>
